
import React from "react";
import {ISampleRatesWrapper} from "../interfaces";
import SearchFilter from "./search-filter";
import {useAppSelector} from "../../product-page/data-services/store";
import {ProductTypeEnum} from "../../product-page/data-services/data-service";


export interface ISampleRatesProps {
    sampleRatesWrapper?:ISampleRatesWrapper
}
/**
 * the entry point
 */
const TabSampleRate = (props?: ISampleRatesProps) => {

    const sampleRatesWrapper = props?.sampleRatesWrapper;
    const techSpecsSearchPlugins = useAppSelector((store) => store.techSpecsSearchPlugins);
    const productDataType = useAppSelector((store) => store.productDataType);

    return (
        <div className="my-4">
            {sampleRatesWrapper != null && <div className={"my-4"} dangerouslySetInnerHTML={{ __html: sampleRatesWrapper?.topBanner }} />}
            {sampleRatesWrapper != null && sampleRatesWrapper.sampleRates.length > 0 &&
                <table className="table-fixed w-full text-base mt-8 rounded">
                    <thead style={{position:productDataType !== ProductTypeEnum.plugin ? "sticky" : "unset",top:(sampleRatesWrapper.topPosition && sampleRatesWrapper.topPosition !== null) ? sampleRatesWrapper.topPosition : "136px"}}>
                    {productDataType !== ProductTypeEnum.plugin &&  <tr>
                        <td className="bg-white" colSpan={10} >
                            <SearchFilter />
                        </td>
                    </tr>}
                    <tr className="h-20 bg-gray-150">
                        <td className="font-bold border pl-4">Plugin</td>
                        <td className="font-bold border text-center-webkit">Sample Rate</td>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        sampleRatesWrapper?.sampleRates?.filter(s=>s.documentName.toLowerCase().includes(techSpecsSearchPlugins.toLowerCase())).map((sr, index) => {
                            return (
                                <tr key={ index }
                                    className="w-full h-20">
                                    <td className="border pl-4">{sr.documentName}</td>
                                    <td className="border text-center-webkit p-2">{sr.sampleRate} kHz <br /> <div className={"w-full"} dangerouslySetInnerHTML={{ __html: sr.sampleRateComment }} /></td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
            }
            {sampleRatesWrapper != null && <div className={"my-8"} dangerouslySetInnerHTML={{ __html: sampleRatesWrapper?.bottomBanner }} />}
        </div>
    )
};

export default TabSampleRate;